import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import BackBtn from "../../common/backBTN";


function Deposit({ items, promotions, userData , transactionData, hasEWallet, usdtRate}){
  const [activeItem, setActiveItem] = useState(null);
	const [activeAmount, setActiveAmount] = useState("");
	const [selectedPromotion, setSelectedPromotion] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [paymentMethod, setPaymentMethod] = useState(null);
	const [paymentSystems, setPaymentSystems] = useState([]);
	const [submitLoading, setSubmitLoading] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [modalMessage, setModalMessage] = useState("");
	const token = localStorage.getItem("token");
	const amounts = ["2000", "3000", "5000", "10000", "15000", "20000", "25000", "1000", "500", "100"];
	const [selectedOption, setSelectedOption] = useState(null);
	const [pgs, setPgs] = useState([]);
	const navigate = useNavigate();
	const [wapy, setWapy] = useState(false);
	const [getotherContracts, setotherContracts] = useState([]);
	const [amountRange, setAmountRange] = useState([100, 25000]);
	const [currency, setCurrency] = useState("৳");
	const [presetAmounts, setPresetAmounts] = useState(["100",  "500", "1000", "2000", "3000", "5000", "10000", "15000", "20000", "25000"]);
	const [depositChannel, setDepositChannel] = useState(false);
	
	const fetchWay = async () => {
  const token = localStorage.getItem('token');
  if (!token) return;

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/wpay/check`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json',
      },
    });

    if (response.status === 200) {
      setWapy(true);
    } else {
      setWapy(false);
      console.warn("WPay check failed:", response);
    }
  } catch (error) {
    console.error("Error fetching WPay check:", error);
    setWapy(false);
  }
};





	const fetchOther = async () => {
        const token = localStorage.getItem('token');
        if (token) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/get/other/phone`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    setotherContracts(data.data || []);
                    console.log(data.data);
                   
                } else {
                    console.error('Failed to fetch user data');
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        }
    };
	
	useEffect(() => { 
		fetchOther();
		fetchWay();
		let uniquePaymentMethods = [];
		const seenNames = new Set();
		console.log("Items in deposit", items);

		if (items && items.length > 0) {
			items.forEach((item) => {
				if (item.name && !seenNames.has(item.name.toLowerCase())) {
					seenNames.add(item.name.toLowerCase());
					uniquePaymentMethods.push(item);
				}
			});
		}
		
		setPgs(uniquePaymentMethods);
		
	}, []);
	  

	// ✅ Auto-select the first payment method
	useEffect(() => {
		if (items.length > 0) {
			setPaymentMethod(items[0]);
		}
	}, [items]);

	// ✅ Auto-select the first promotion
	

	// ✅ Fetch deposit channels when payment method changes
	useEffect(() => {
		console.log("eWa", hasEWallet);
		if (paymentMethod && hasEWallet===false) {
			const fetchPaymentMethodDetails = async () => {
				try {
				const response = await fetch(`${process.env.REACT_APP_API_URL}/api/showpayment-menthod?name=${paymentMethod.name}`, {
					headers: { Authorization: `Bearer ${token}`, 'Origin': window.location.origin },
				});
				const data = await response.json();

					if (data?.success && data.data.length > 0) {
					setPaymentSystems(data.data);
					setSelectedOption(data.data[0]?.id || null);
				}
				} catch (error) {
					console.error("Error fetching payment method details:", error);
				} finally {
					setIsLoading(false);
				}
			};
			fetchPaymentMethodDetails();
		}
		if (hasEWallet === true) {
			
			setTimeout(() => {
				let _filtered = [];
				for (let i = 0; i < items.length; i++) {
					// console.log('X',items[i]?.name, paymentMethod?.name);
					if (items[i]?.name.toLowerCase() === paymentMethod?.name.toLowerCase()) {
						_filtered.push(items[i]);
					}
				}
				setPaymentSystems(_filtered);
				setSelectedOption(_filtered[0]?.id || null);
				setIsLoading(false);
			}, 400);
		}
	}, [paymentMethod, token]);


	useEffect(() => { 
		const selectedMethod = items.find((item) => item.id === selectedOption);
		if (selectedMethod?.account_type === 'USDT') {
				setAmountRange([10,200])
				setCurrency('$');
				setPresetAmounts(["10", "20", "30", "50", "100", "150", "200"]);
				setDepositChannel(false);
			} else {
				setAmountRange([100, 25000]);
				setCurrency('৳');
				setPresetAmounts(["100", "500", "1000", "2000", "3000", "5000", "10000", "15000", "20000", "25000"]);
				setDepositChannel(true);
			}
	}, [selectedOption, items]);

	const handleItemClick = (name) => {
		const selectedMethod = items.find((item) => item.name === name);
		if (selectedMethod) {
			setPaymentMethod(selectedMethod);
		}
		setTimeout(() => {
			let _filtered = [];
			for (let i = 0; i < items.length; i++) {
				// console.log('X', items[i]?.name, paymentMethod?.name);
				if (items[i]?.name.toLowerCase() === paymentMethod?.name.toLowerCase()) {
					_filtered.push(items[i]);
				}
			}
			// console.log("Filtered DD", _filtered);
			setPaymentSystems(_filtered);
			setSelectedOption(_filtered[0]?.id || null);
		}, 200);
	};

	const handleSelection = (id) => {
		setSelectedOption(id);
	};

	const handleAmountClick = (amount) => {
		setActiveAmount(amount);
	};

	const handlePromotionChange = (event) => {
		const selectedId = parseInt(event.target.value);
		const selectedPromo = promotions.find((promo) => promo.id === selectedId);
		setSelectedPromotion(selectedPromo || null);
	};

	const handleSubmit = async () => {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
    event: 'deposit_submit',
    category: 'Deposit',
    action: 'Submit',
    label: 'Deposit Form Submit',
    currency: 'BDT'
  });

		if (transactionData && transactionData.length > 0) {
			for (let trns of transactionData) {

				const keyValue = Number(trns.key);   

				if (trns.action?.toLowerCase() === "deposit" && keyValue === 0) {
					setModalMessage(
						"You already have a deposit request pending. Please wait for it to be processed before making another deposit."
					);
					setShowModal(true);
					return;
				}
			}
		}

		
		if (!activeAmount) {
			setModalMessage("Please fill in your amount.");
			setShowModal(true);
			return;
		}

		if (!paymentMethod) {
			setModalMessage("Please select a valid payment method.");
			setShowModal(true);
			return;
		}

		const selectedPaymentSystem = paymentSystems.find(item => item.id === selectedOption);
		if (!selectedPaymentSystem) {
			setModalMessage("Please select a Deposit channel.");
			setShowModal(true);
			return;
		}

		try {
			if (hasEWallet) { 
				try {
					const response = await fetch(`${process.env.REACT_APP_API_URL}/api/ewa/request`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': `Bearer ${token}`,
							'Origin': window.location.origin,
						},
						body: JSON.stringify({
							amount: activeAmount,
							type: selectedPaymentSystem.account_type,
							provider: paymentMethod.name,
							promotion: selectedPromotion?.id || 0,
						}),
					});
					const data = await response.json();
					
					if (response.ok) {
						if (data?.url) {
							window.location.href = data.url;
							return;
						}
						console.log("Ewallet Request Data:", data);
						navigate("/make-payment", {
							state: {
								amount: data?.amount ?? activeAmount,
								payment_icon: selectedPaymentSystem?.icon,
								payment_type: selectedPaymentSystem?.account_type,
								paymentMethodid: paymentMethod?.id,
								paymentMethodName: paymentMethod?.name,
								promotion: selectedPromotion?.id || null,
								transaction: data?.transaction,
								number: data?.number,
								timer: data?.timer ?? 10, 
								message: data?.message
							},
						});
						console.log("Navigation to make-payment with state:", {
							amount: data?.amount ?? activeAmount,
							payment_icon: selectedPaymentSystem?.icon,
							payment_type: selectedPaymentSystem?.account_type,
							paymentMethodid: paymentMethod?.id,
							paymentMethodName: paymentMethod?.name,
							promotion: selectedPromotion?.id || null,
							transaction: data?.transaction,
							number: data?.number,
							timer: data?.timer ?? 10,
							message: data?.message
						});
					}
					else {
						setModalMessage(data?.message || "An error occurred. Please try again.");
						setShowModal(true);
					}
					// } else {
					// }
				} catch (error) { 
					let err = error?.response?.data?.message || "An error occurred. Please try again.";
					setModalMessage(err || "An error occurred. Please try again.");
					console.error("Error fetching e-wallet request:", error);
					setModalMessage("An error occurred. Please try again.");
					setShowModal(true);
				}

			}
			else if (wapy) {
					const baseUrl = `${process.env.REACT_APP_API_URL}/api/payin`;

					
					const params = new URLSearchParams({
						amount: activeAmount,
						method: (paymentMethod?.name || '').toUpperCase(),
					});

					if (selectedPromotion?.id) {
						params.append("promotion", selectedPromotion.id);
					}

					const url = `${baseUrl}?${params.toString()}`;
					

					try {
						const response = await fetch(url, {
						method: "GET",
						headers: {
							"Authorization": `Bearer ${token}`,
							"Accept": "application/json",
						},
						});

						const data = await response.json();
						
						window.open(data[0].data.url, "_blank");
					} catch (error) {
						console.error("Error calling PayIn API:", error);
					}
					}  else {
				navigate("/make-payment", {
					state: {
						amount: activeAmount,
						payment_icon: selectedPaymentSystem.icon,
						payment_type: selectedPaymentSystem.account_type,
						paymentMethodid: paymentMethod.id,
						paymentMethodName: paymentMethod.name,
						promotion: selectedPromotion?.id || null,
					},
				});
			}
		} catch (error) {
			setModalMessage("An error occurred. Please try again.");
			setShowModal(true);
		} finally {
			setSubmitLoading(false);
		}
	};
	const [selectedBrand, setSelectedBrand] = useState('localhost');
	useEffect(() => {
		const hostname = (window.location.hostname || '').toLowerCase();
		const origin = (window.location.origin || '').toLowerCase();
		const search = (window.location.search || '').toLowerCase();
		const params = new URLSearchParams(window.location.search);
		const brand = ((process.env.REACT_APP_BRAND || localStorage.getItem('brand') || '')).toLowerCase();
	
		const isBeetbuzz = hostname.includes('beetbuzz') || origin.includes('beetbuzz') || brand.includes('beetbuzz');
		const isLocalhost = hostname.includes('localhost') || origin.includes('localhost') || brand.includes('localhost');
		const isBk8bd = hostname.includes('bk8bd') || origin.includes('bk8bd') || brand.includes('bk8bd');
		const isCb444 = hostname.includes('cb444') || origin.includes('cb444') || brand.includes('cb444');
		const isrocket88 = hostname.includes('rocket88') || origin.includes('rocket88') || brand.includes('rocket88');
	
		const selectedBrand = isrocket88 ? 'rocket88' : isBeetbuzz ? 'beetbuzz' : isLocalhost ? 'localhost' : (isBk8bd || isCb444) ? 'bk8bd' : 'default';
	
		localStorage.setItem('brand', selectedBrand);
		setSelectedBrand(selectedBrand);
	  
		
	  
	  
	   
	  }, []);

	  useEffect(() => {
  if (selectedBrand === "rocket88" && promotions.length > 0) {
    setSelectedPromotion(promotions[0]); 
  }
}, [selectedBrand, promotions]);

	if (isLoading) {
		return (
		<p>Loading...</p>
		);
	}
		return(
			<>
				<div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
  <div className="my-home">
    <div className="ios-version" id="v2-vc-container">
      {/* react-text: 1806 */}{/* /react-text */}
      <div className="mc-header-wrap">
        <div id="mc-header" className="mc-navbar-blue mc-voucherCenter mc-default-header am-navbar am-navbar-light">
          <BackBtn/>
          <div className="am-navbar-title">Deposit</div>
          <div className="am-navbar-right">
            <Link to={'/withdraw'} className="right-wrapper">
              <div className="report-icon">
               
                <svg className="am-icon am-icon-voucher_list_b99e1f01 am-icon-md am-navbar-title"><use xlinkHref="#voucher_list_b99e1f01" /></svg>
              </div>
              <div className="cs-icon">
                <svg className="am-icon am-icon-service_c87ca62b am-icon-md am-navbar-title"><use xlinkHref="#service_c87ca62b" /></svg>
              </div>
            </Link>
          </div>
        </div>
        <div className="am-whitespace am-whitespace-sm mc-whitespace" />
      </div>
      <div className="vc-scroll-container">
        <div className="vc-v2-container">
          <div className="pd-btm-20 ranndom-container">
            <div className="vc-v2-title">Deposit Method</div>
            <div className="min-list vc-v2-method show-more-container">
              <ul>
                {pgs.map(
				(item) =>
				item.status === "active" && (
                <li className={`change-item-animate ${item.name} recommendation ${paymentMethod?.name === item.name ? "ck" : ""}`} key={item.id} onClick={() => handleItemClick(item.name)}>
                  {paymentMethod?.name === item.name && (
                  <svg className="am-icon am-icon-checked_0a488f7d am-icon-md deposit-list-ck"><use xlinkHref="#checked_0a488f7d" /></svg>
                  )}
				  
					 <div className="deposit-img-new"><img 	src={`./${item.icon}`} alt="" style={{display: 'block'}} /></div>
				  
                 
                  <div className="desc-content">
                    <div className="desc-info">
                      <div className="vcn-list-text"><p>{item.name}</p></div>
                    </div>
                  </div>
                </li>
                )
							)}
              </ul>
            </div>
          </div>
          <div className="vc-v2-space-content vc-v2-space-content" />
          <div className>
            {depositChannel && (
            <div className="ranndom-container pay-way-container">
              <div className="vc-v2-title pay-way">Payment channels</div>
              <div className="vc-v2-method-list">
                <ul>
                  {paymentSystems.map(ps => (
                    <li className={`${
						ps.account_type === "Agent" ? "recommendation" : ""
						} ${selectedOption === ps.id ? "ck" : ""}`} key={ps.id} onClick={() => {handleSelection(ps.id); setActiveItem(ps.id)}}>
                     
								{ps.account_type === "Agent" ? (
								<span className="method-list-info">Cashout</span>
							) : ps.account_type === "Personal" ? (
								<span className="method-list-info">Send Money</span>
							) : (
								<span className="method-list-info">Merchant</span>
							)}

                    </li>
                  ))}
                </ul>
              </div>
            </div>
            )}
            {/* react-empty: 1846 */}
            <div className="ranndom-container hide">
              <div className="vc-v2-title pay-name">ID number</div>
              <div className="vc-v2-input">
                <div className="inputCon"><input type="text" inputMode="text" className="inputBase" placeholder="Please enter your ID number" name="idNumber" defaultValue /></div>
              </div>
            </div>
            <div className="ranndom-container hide">
              <div className="vc-v2-title pay-name">Bank Account Name</div>
              <div className="vc-v2-input">
                <div className="inputCon"><input type="text" inputMode="text" className="inputBase" placeholder="Bank Account Name" name="payee" defaultValue /></div>
              </div>
            </div>
            <div className="ranndom-container hide">
              <div className="vc-v2-title pay-name">Nickname</div>
              <div className="vc-v2-input no-border">
                <div className="inputCon"><input type="text" inputMode="text" className="inputBase" placeholder="Please enter a nickname" name="nickname" /></div>
              </div>
            </div>
            {/* react-text: 1862 */}{/* /react-text */}
            <div className>
              <div id="payAmount" className="ranndom-container vc-v2-amount">
                <div className="vc-v2-title pay-amount">Deposit Amounts</div>
                <div className="vc-v2-input">
                  <div className="deposit-amount-con">
                    <div className="fixed-money">
						{presetAmounts.map((amount) => (

                      <div key={amount} onClick={() => handleAmountClick(amount)} className={`fixed-money-item number-mc ${activeAmount === amount ? 'money-active' : ''}`}>
						{activeAmount === amount && <svg className="am-icon am-icon-checked_0a488f7d am-icon-md deposit-list-ck"><use xlinkHref="#checked_0a488f7d" /></svg>}

						<div className={`bonus-tip money-active null ${selectedPromotion ? "hasBonus" : ""}`}>+ {((Number(amount) * Number(selectedPromotion?.deposit_bouns)) / 100).toFixed(2)}</div>
						{amount}</div>
					  ))}
                     
                    </div>
                    <div>
                      <div className="inputCon false">
                        <i>৳</i><input type="text" value={activeAmount} onChange={(e) => setActiveAmount(e.target.value)} onClick={(e) => e.stopPropagation()} inputMode="decimal" maxLength={11} placeholder="100 - 50,000" className="inputBase" name="deposit" />
                        
                      </div>
                     
                    </div>
                  </div>
                </div>
                {/* react-text: 1874 */}{/* /react-text */}
              </div>
              <div className="am-flexbox am-flexbox-align-middle errors">
                <div className="am-flexbox-item">
                  <span className="hide">
                    {/* react-text: 1878 */}Handling fee{/* /react-text */}{/* react-text: 1879 */}:{/* /react-text */}
                    <i />
                  </span>
                </div>
              </div>
            <div className="ranndom-container vc-v2-space vc-v2-active" id="vc-v2-active">
  <div className="vc-v2-title pay-active">Promotions</div>

  <div className="vc-v2-active-container">
    <div className="am-flexbox am-flexbox-align-middle deposit-promo-v2 flex-con">
      <div className="am-flexbox-item">
        <div className="act-container">
          
          {promotions.map((promo) => (
            <div
              key={promo.id}
              className={`act-item ${selectedPromotion?.id === promo.id ? "on" : ""} ${activeAmount ? "" : "dis"}`}
              onClick={() => setSelectedPromotion(promo)} 
            >
              <div className="act-prom-name act-prom-remark-v2-container">
                <div className="act-name">🎁 {promo.name}</div>
				
                <div className="act-mount">
                 {selectedBrand !== 'beetbuzz' && (
			<>
				≥ <i>৳ {promo.minimum_amount_deposit_for_bonus}</i>
			</>
			)}

				  
                </div>
              </div>

              <div className={` ${selectedPromotion?.id === promo.id ? "act-prom-remark" : "act-prom-remark-v2"}`}>
                <div
                  className="wysiwyg"
                  dangerouslySetInnerHTML={{ __html: promo.desc }}
                />
              </div>
            </div>
          ))}

          
          <div
  className={`act-item ${selectedPromotion === null ? "on" : ""} ${
    selectedBrand === "rocket88" ? "hidden-option" : ""
  }`}
  onClick={() => setSelectedPromotion(null)}
>
  <div className="act-prom-name">
    Do not participate in any promotions
  </div>
</div>


        </div>
      </div>
    </div>
  </div>
</div>


              <div className="ranndom-container hide">
                <div className="vc-v2-title pay-dc vc-v2-space">
                  <div className="am-flexbox am-flexbox-align-middle flex-con-new flex-another-pay flex-pay-showborder hide">
                    {/* react-text: 1887 */}Deposit on behalf{/* /react-text */}
                    <span>
                      {/* react-text: 1889 */}
                      {/* /react-text */}{/* react-text: 1890 */}Click to deposit for other user.{/* /react-text */}
                    </span>
                    <div className="agrg-downline-type switch-box setting_sort_right">
                      <div className="mc-switch mc-qutas-bg"><div className="checkbox" /></div>
                      <span className="agrg-downline-cname other-size">Deposit on behalf</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="vc-v2-other vc-v2-input">
                <div className="am-flexbox am-flexbox-align-middle hide flex-con flex-con-other">
                  <div className="am-flexbox-item">
                    <div className="inputCon"><input type="text" inputMode="text" maxLength={15} className="inputBase" placeholder="Please enter the user name" name="targetName" /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hide"><div className="vc-v2-submit">Wallet address</div></div>
      <div  className={`vc-v2-submit ${activeAmount ? "" : "dis"}`}  onClick={handleSubmit}>
        <i className="arrow-down" />
        <div>Next</div>
      </div>
      {/* react-empty: 1904 */}
    </div>
  </div>

        </div>

		{showModal && (
			<div
				role="dialog"
				aria-live="assertive"
				aria-modal="true"
				onClick={() => setShowModal(false)}
				style={{
					position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
					display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999
				}}
			>
				<div onClick={(e) => e.stopPropagation()} style={{
					width: '88%', maxWidth: 420, background: '#101214', color: '#fff',
					borderRadius: 12, boxShadow: '0 10px 30px rgba(0,0,0,0.4)',
					padding: 16, border: '1px solid #ff6666'
				}}>
					<div style={{ display:'flex', alignItems:'center', gap:8, marginBottom: 8 }}>
						<span style={{ width: 10, height: 10, borderRadius: '50%', background: '#ff6666' }}/>
						<strong>Error</strong>
					</div>
					<div style={{ whiteSpace:'pre-wrap' }} dangerouslySetInnerHTML={{ __html: modalMessage }} />
					<div style={{ display:'flex', justifyContent:'flex-end', marginTop: 12 }}>
						<button onClick={() => setShowModal(false)} style={{
							background:'#ff6666', color:'#fff', border:0, borderRadius:8, padding:'8px 14px', cursor:'pointer'
						}}>OK</button>
					</div>
				</div>
			</div>
		)}

		</>
		);

}
export default Deposit;